// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OzQK","badges":"styles_badges__3scCk"};